import { Default, TechFormatNumer, TechGetDecimalInfo, Utils } from '../utils';
import { FormatsService } from '../formats.service';

import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trInteger',
})
@Injectable({ providedIn: 'root' })
export class IntegerPipe implements PipeTransform {
  constructor(private formats: FormatsService) {}

  transform(value: number): string {
    if (!Utils.isValue(value)) return '--';

    const decimalPlaces = TechGetDecimalInfo(
      Default.digitsIntegerInfo.toString()
    );

    // Redondear el número a la cantidad deseada de decimales
    const roundedNumber = value.toFixed(decimalPlaces);

    const t = TechFormatNumer(
      roundedNumber,
      this.formats.decimalCharacter,
      this.formats.digitGroupSeparator
    );

    return t;
  }
}
